import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ l.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M24.045 40h-7.28a2 2 0 0 1-1.954-1.572l-.814-3.768a16 16 0 0 1-3.07-1.774l-3.674 1.17a2 2 0 0 1-2.34-.906l-3.648-6.302a2.01 2.01 0 0 1 .386-2.478l2.85-2.6a16.2 16.2 0 0 1 0-3.544l-2.85-2.594a2.01 2.01 0 0 1-.386-2.48l3.64-6.306a2 2 0 0 1 2.34-.906l3.674 1.17q.733-.542 1.52-1a17 17 0 0 1 1.558-.772l.816-3.764A2 2 0 0 1 16.765 0h7.28a2 2 0 0 1 1.952 1.574l.824 3.766a16.4 16.4 0 0 1 3.07 1.774l3.676-1.17a2 2 0 0 1 2.338.906l3.64 6.306a2.014 2.014 0 0 1-.386 2.478l-2.85 2.6a16.2 16.2 0 0 1 0 3.544l2.85 2.6c.69.636.85 1.664.386 2.478l-3.64 6.306a2 2 0 0 1-2.34.906l-3.674-1.17a16 16 0 0 1-3.068 1.772l-.826 3.758A2 2 0 0 1 24.045 40m-3.648-28a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
    fill: "currentColor"
  }
) });
export {
  o as S
};
